function getDomain() {
  return window.location.host.match(/editorx.com/) ? 'manage.editorx.com' : 'manage.wix.com';
}

export function getUserProfileUrl() {
  const domain = getDomain();
  return `https://${domain}/_api/wix-html-login-webapp/user/getUserDetails`;
}

export function getUserImageUrl() {
  const domain = getDomain();
  return `https://${domain}/_api/account-info-server/profileimage`;
}

export function request(url: string, onSuccess: (response: any) => void, onError: () => void) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url);
  xhr.withCredentials = true;
  xhr.send();
  xhr.onload = function () {
    try {
      const response = JSON.parse(xhr.response);
      if (xhr.status !== 200) {
        onError && onError();
      } else {
        onSuccess && onSuccess(response);
      }
    } catch (e) {
      onError && onError();
    }
  };
  xhr.onerror = function () {
    onError && onError();
  };
}
